import React from "react";
import { Link } from "react-router-dom";
import "swiper/css/autoplay";
// import Swiper core and required modules
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
  Autoplay,
  EffectFade,
  Navigation,
  Pagination,
} from "swiper";
SwiperCore.use([Navigation, Pagination, EffectFade, Autoplay]);
// install Swiper modules
function HeroArea() {
  const HeroSlider = {
    slidesPerView: 1,
    speed: 5500,
    spaceBetween: 0,
    loop: "true",
    clickable: true,
    autoplay: true,
    effect: "fade",
    centeredSlides: true,
    roundLengths: true,
    fadeEffect: {
      crossFade: true,
    },
  };
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <section className="hero-area">
        <div className="swiper hero-slider">
          <Swiper
            pagination={{
              type: "bullets",
              clickable: true,
            }}
            {...HeroSlider}
            loop={true}
            className="swiper-wrapper"
          >
            <SwiperSlide className="swiper-slide">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="hero-content-wrapper">
                      <div className="hero-content-wrap">
                        <div className="hero-content-img">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/images/hero-slider-1.jpg"
                            }
                            alt="Abeos création site web performant et maintenance experte"
                          />
                        </div>
                        <div className="hero-content">
                          <h2>Creative</h2>
                          <h1>
                            Boostez votre présence web avec une <span>solution sur-mesure.</span>
                          </h1>
                          <p>
                            Nous créons des sites web performants qui transforment vos visiteurs en clients. Conception responsive, SEO intégré : des résultats garantis.
                          </p>
                          <Link
                            onClick={scrollTop}
                            to={`${process.env.PUBLIC_URL}/about`}
                            className="about-btn"
                          >
                            Découvrez Abeos
                          </Link>
                          <Link
                            onClick={scrollTop}
                            to={`${process.env.PUBLIC_URL}/contact`}
                            className="work-btn"
                          >
                            Lancez votre projet
                          </Link>
                          <div className="slider-num">
                            <span>01</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide className="swiper-slide">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="hero-content-wrapper">
                      <div className="hero-content-wrap">
                        <div className="hero-content-img">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/images/hero-slider-2.png"
                            }
                            alt="Abeos création site web performant et maintenance experte"
                          />
                        </div>
                        <div className="hero-content">
                          <h2>Innovant</h2>
                          <h1>
                            <span>Apps web innovantes</span> et designs percutants pour vos idées.
                          </h1>
                          <p>
                            Développez des applications web fluides et scalables. Nos designers créent des interfaces uniques pour captiver et fidéliser vos utilisateurs.
                          </p>
                          <Link
                            onClick={scrollTop}
                            to={`${process.env.PUBLIC_URL}/about`}
                            className="about-btn"
                          >
                            Découvrez Abeos
                          </Link>
                          <Link
                            onClick={scrollTop}
                            to={`${process.env.PUBLIC_URL}/contact`}
                            className="work-btn"
                          >
                            Créez votre app
                          </Link>
                          <div className="slider-num">
                            <span>02</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide className="swiper-slide">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="hero-content-wrapper">
                      <div className="hero-content-wrap">
                        <div className="hero-content-img">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/images/hero-slider-3.png"
                            }
                            alt="Abeos création site web performant et maintenance experte"
                          />
                        </div>
                        <div className="hero-content">
                          <h2>Maintenance</h2>
                          <h1>
                            <span>Croissance continue</span> assurée avec notre maintenance experte.
                          </h1>
                          <p>
                           Nous gérons les mises à jour, la sécurité et l’optimisation de votre site. Évitez les pannes et gagnez en performance : on s'occupe de tout.
                          </p>
                          <Link
                            onClick={scrollTop}
                            to={`${process.env.PUBLIC_URL}/about`}
                            className="about-btn"
                          >
                            Découvrez Abeos
                          </Link>
                          <Link
                            onClick={scrollTop}
                            to={`${process.env.PUBLIC_URL}/contact`}
                            className="work-btn"
                          >
                            Devis gratuit
                          </Link>
                          <div className="slider-num">
                            <span>03</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
          <div className="swiper-pagination" />
        </div>
        <div className="social-media">
          <ul className="social-list">
            <li>
              <a rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/share/16csVgY7ie/?mibextid=wwXIfr">
                Facebook
              </a>
            </li>
            <li>
              <a rel="noopener noreferrer" target="_blank" href="https://www.instagram.com/abeos_build_your_future?igsh=MWRsOWtvcXY4NDlpdg%3D%3D&utm_source=qr">
                instagram
              </a>
            </li>
            <li>
              <a rel="noopener noreferrer" target="_blank" href="https://www.linkedin.com/">
                Linked in
              </a>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
}

export default HeroArea;
